var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardSection',{attrs:{"title":_vm.title,"description":_vm.description,"data-external":"popular-categories-carousel","mobile":{
    cardMode: 'scroll',
    cardFlexBasis: 'calc(100%/3)',
    cardSpacing: '8px',
    peek: true,
  },"tablet":{
    cardFlexBasis: 'calc(100%/4)',
    showSteppers: true,
    peek: false,
    cardSpacing: '16px',
  },"desktop":{
    cardFlexBasis: 'calc(100%/5)',
    peek: false,
    cardSpacing: '32px',
  }}},_vm._l((_vm.categories),function(category,i){return _c('CategoryCardFlat',{key:i,attrs:{"title":category.content.name,"image-src":_vm.getStoryblokImageURL(category.content.thumb_image.filename, { width: 250 }),"image-alt":category.content.thumb_image.alt,"link":_vm.getCategoryCarouselLink(category)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }